import Axios from 'axios'
import {paymentMethodUrls} from '../urls'
import router from '../../../router'

export default {
  get_all_donation_payment_methods (context) {
    Axios.get(paymentMethodUrls.getAllPaymentMethods).then(function (response) {
      context.commit('GET_ALL_PAYMENT_METHODS', response.data)
    })
  },
  get_payment_methodss (context, publicId) {
    Axios.get(paymentMethodUrls.getPaymentMethods + publicId).then(function (response) {
      context.commit('GET_PAYMENT_METHODS', response.data)
    })
  },
  get_deleted_payment_methodss (context) {
    Axios.get(paymentMethodUrls.getDeletedPaymentMethod).then(function (response) {
      context.commit('GET_DELETED_PAYMENT_METHODS', response.data)
    })
  },
  get_payment_methods (context, publicId) {
    Axios.get(paymentMethodUrls.getPaymentMethod + publicId).then(function (response) {
      context.commit('GET_PAYMENT_METHOD', response.data)
    })
  },
  post_payment_methods (context, data) {
    Axios.post(paymentMethodUrls.postPaymentMethod, data).then(function () {
      context.dispatch('get_all_payment_methodss')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
     
    })
  },
  update_payment_methods (context, data) {
    Axios.post(paymentMethodUrls.editPaymentMethod, data).then(function () {
      context.dispatch('get_all_payment_methodss')
      router.push({
        name: data.redirect_url
      })
    }).catch(function (error) {
      context.commit('UPDATE_ERRORS', error.data)
     
    })
  },
  delete_payment_methods (context, publicId) {
    Axios.get(paymentMethodUrls.deletePaymentMethod + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_DELETED_PAYMENT_METHODS', response.data)
      router.push({
        name: 'Module.DeletedPaymentMethods'
      })
    })
  },
  restorePaymentMethod (context, publicId) {
    Axios.get(paymentMethodUrls.restorePaymentMethod + publicId).then(function (response) {
      alert(response.data.message)
      context.commit('GET_ALL_PAYMENT_METHODS', response.data)
      router.push({
        name: 'Module.PaymentMethods'
      })
    })
  }
}
